"use strict";
/**
 * D1 Behavior Detection
 *
 * Utilities to detect how Prisma is returning JSON fields.
 * This helps future-proof the code if Prisma's D1 adapter
 * ever starts auto-parsing JSON fields.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectPrismaJsonBehavior = detectPrismaJsonBehavior;
exports.isD1ReturningStrings = isD1ReturningStrings;
exports.logD1Behavior = logD1Behavior;
/**
 * Detect whether a value from Prisma is a string or already parsed
 * @param value - Value to check
 * @returns 'string' if JSON needs parsing, 'parsed' if already an object
 */
function detectPrismaJsonBehavior(value) {
    return typeof value === "string" ? "string" : "parsed";
}
/**
 * Check if Prisma D1 adapter is returning strings for JSON fields
 * @param sampleRow - A sample row from the database
 * @returns true if JSON fields are strings, false if already parsed
 */
function isD1ReturningStrings(sampleRow) {
    // Check common JSON fields
    var jsonFields = ["board", "bar", "off", "dice", "moves"];
    for (var _i = 0, jsonFields_1 = jsonFields; _i < jsonFields_1.length; _i++) {
        var field = jsonFields_1[_i];
        if (field in sampleRow && typeof sampleRow[field] === "string") {
            return true;
        }
    }
    return false;
}
/**
 * Log D1 behavior for debugging
 * @param sampleRow - A sample row to analyze
 */
function logD1Behavior(sampleRow) {
    console.log("[D1 Behavior Detection]");
    console.log("Sample row type checks:");
    var fields = ["board", "bar", "off", "dice", "moves"];
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        if (field in sampleRow) {
            console.log("  ".concat(field, ": ").concat(typeof sampleRow[field]));
            if (typeof sampleRow[field] === "string") {
                console.log("    Sample: ".concat(sampleRow[field].substring(0, 50), "..."));
            }
        }
    }
    var needsParsing = isD1ReturningStrings(sampleRow);
    console.log("Conclusion: JSON fields ".concat(needsParsing ? "NEED" : "DO NOT NEED", " parsing"));
}
//# sourceMappingURL=detection.js.map